const development = false
exports.BASE_URL = development ? 'http://localhost:4010' : 'https://api.mylandcodingcenter.com'
